import { withTeamConfig } from "@/global/context/AppProviderRoot";
import { useTeamConfig } from "@/global/hooks/useTeamConfig";
import { useMlbBallparkStore } from "@/global/store/useMlbBallparkStore";
import { Box, Stack, CircularProgress } from "@mui/material";
import { useRouter } from "next/router";
import { useEffect } from "react";

const IndexPage = (props: any) => {
  const router = useRouter();
  const { teamSchema, defaultRoute } = useTeamConfig();
  const mlbBallparkStore = useMlbBallparkStore();

  useEffect(() => {
    router.push({
      pathname: defaultRoute,
      query: {
        ...router.query,
        teamSchema,
      },
    });
  }, []);

  useEffect(() => {
    if (props?.mlbBallparkOktaId) {
      mlbBallparkStore.set({ mlbBallparkOktaId: props?.mlbBallparkOktaId });
    }
  }, []);

  return (
    <Box height={"100vh"}>
      <Stack
        width={"100%"}
        height="100vh"
        alignItems={"center"}
        justifyContent={"center"}
      >
        <CircularProgress size={"64px"} color="primary" />
      </Stack>
    </Box>
  );
};

export default withTeamConfig(IndexPage);

export const getServerSideProps = async (ctx: any) => {
  const { req } = ctx;
  // x-bp-uid is the header that contains the id
  const mlbBallparkOktaId = req?.headers?.["x-bp-uid"] ?? null;

  return { props: { mlbBallparkOktaId } };
};
